import React, { useEffect } from 'react';
import { Header, Footer } from '../components/layout';
import { EmailVerificationBanner } from '../components/common/EmailVerificationBanner';
import { WatchlistDashboard } from '../features/watchlist/WatchlistDashboard';
import { useAuth } from '../contexts/AuthContext';

export const DashboardPage: React.FC = () => {
  const { refreshProfile, isEmailVerified } = useAuth();

  useEffect(() => {
    if (!isEmailVerified) {
      refreshProfile();
    }
  }, [isEmailVerified, refreshProfile]);

  return (
    <div className="min-h-screen flex flex-col justify-between bg-slate-50 dark:bg-slate-950 transition-colors">
      <Header />
      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <EmailVerificationBanner />
        <WatchlistDashboard />
      </main>
      <Footer />
    </div>
  );
};
